import { useEffect, useRef } from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { useUpdatePaymentStatus } from "./update_status";

const DonateButton = ({
  currency,
  amount,
  setActivePaymentMethod,
  selectedPlan,
}) => {
  const amountRef = useRef(amount);
  const updatePaymentStatus = useUpdatePaymentStatus();

  useEffect(() => {
    amountRef.current = amount;
  }, [amount]);

  if (!amount) {
    return;
  }

  return (
    <PayPalButtons
      style={{ color: "black", label: "donate" }}
      fundingSource="paypal"
      // createOrder={(data, actions) => {
      //   return actions.order.create({
      //     purchase_units: [
      //       {
      //         amount: {
      //           value: amountRef.current,
      //           breakdown: {
      //             item_total: {
      //               currency_code: currency,
      //               value: amountRef.current,
      //             },
      //           },
      //         },
      //         items: [
      //           {
      //             name: "Mathspeedup",
      //             quantity: "1",
      //             unit_amount: {
      //               currency_code: currency,
      //               value: amountRef.current,
      //             },
      //             category: "DONATION",
      //           },
      //         ],
      //       },
      //     ],
      //     application_context: {
      //       shipping_preference: "NO_SHIPPING",
      //     },
      //   });
      // }}
      // onApprove={(data, actions) => {
      //   return actions.order
      //     .capture()
      //     .then((details) => {
      //       setActivePaymentMethod(null);
      //     })
      //     .catch((error) => {
      //       console.error("Capture error", error);
      //     });
      // }}
      createOrder={(data, actions) => {
        return actions.order.create({
          purchase_units: [
            {
              amount: {
                value: amountRef.current,
              },
            },
          ],
          application_context: {
            shipping_preference: "NO_SHIPPING",
          },
        });
      }}
      onApprove={(data, actions) => {
        return actions.order
          .capture()
          .then((details) => {
            setActivePaymentMethod(null);
            updatePaymentStatus(selectedPlan);
          })
          .catch((error) => {
            console.error("Capture error", error);
          });
      }}
    />
  );
};

export default DonateButton;
